import { NamedValueResponse } from '../../../shared/models/named-value-response.model';

export class VisitType extends NamedValueResponse{
}